import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PaginationInstance } from 'ngx-pagination';
import { AdminService } from '../../../../services/admin.service';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { ReportsFilterComponent } from '../../../../common/reports-filter/reports-filter.component';
import { ReportsServiceService } from '../../../../services/reports-service';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { BehaviorSubject } from 'rxjs';
import { WebClientConfigurationService } from '../../../../services/configuration/web-client-configuration.service';

@Component({
  selector: 'app-instance-override-report',
  templateUrl: './instance-override-report.component.html',
  styleUrls: ['./instance-override-report.component.css']
})
export class InstanceOverrideReportComponent implements OnInit {

  config: PaginationInstance;
  resultError: string;
  reportResult;
  submitted: boolean;
  filter: any;
  filterCollapse$: BehaviorSubject<boolean>;
  p = 1;
  total: number;

  @ViewChild('reportsFilterComponent', { static: false }) reportsFilterComponent: ReportsFilterComponent;

  constructor(
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private bpService: BusinessProcessService,
    private reportService: ReportsServiceService,
    private modalService: GenericModalService,
    private webClientConfig: WebClientConfigurationService,
  ) { }

  ngOnInit() {
    this.submitted = false;
    this.filterCollapse$ = new BehaviorSubject(false);
  }

  getFilter(filter) {
    this.filter = filter;
    this.filterCollapse$.next(true);
    this.searchReport(1);
  }

  searchReport(page) {
    this.filter.pageIndex = page - 1;
    this.filter.stateLifeCycle = this.filter.stateLifeCycleValue;

    this.submitted = false;
    this.reportResult = null;
    this.resultError = '';

    this.reportService.getInstanceOverrideReport(this.filter)
      .subscribe(result => {
          this.submitted = true;
          this.reportResult = result;
          this.total = result.total;
          this.p = 1;
          this.getPaginationConfig(page, result.total);
          if (result) {
            console.log(result);
            this.reportResult = result.items;
          }
        },
          error => {
          this.resultError = error;
        }
      );
  }

  onResetFilter() {
    this.submitted = false;
    this.resultError = '';
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.resultError = '';
    this.webClientConfig.getPageSizeConfig()
      .subscribe(item => {
        this.config  = {
          id: 'server',
          itemsPerPage: item,
          currentPage: _currentPage,
          totalItems: _totalItems
        };
      }, error1 => this.resultError = error1);
  }

  onStatusClick(text) {
    this.modalService.showInfoMessage(text, true, undefined, 'Detalhes da falha na imposição:');
  }

  onDetailsClick(businessProcessInstanceId) {
    window.open(`/instanceHistoryDetails/${businessProcessInstanceId}`, '_blank', 'width=1800,height=850,toolbar=no,resizable=yes,alwaysRaised=true,scrollbars=yes,location=no');
  }

}
